import { isType } from '@zaibot/fsa';
import { bookmarksResource } from '../bookmarks/resource';
import { categoriesResource } from '../categories/resource';
import { notesResource } from '../notes/resource';

import RETRY from './actions/RETRY';
import { beheerResource } from '../../admin/resource';
import { questionsResource } from '../question/resource';

export default (store: any) => (next: any) => (action: any) => {
    if (isType(action, RETRY)) {
        const notes = notesResource.selectors.items(store.getState()).filter((x) => notesResource.fields.error(x));
        for (const note of notes) {
            if (notesResource.fields.neverCommited(note)) {
                store.dispatch(notesResource.actions.CREATE({ item: note }));
            } else {
                store.dispatch(notesResource.actions.UPDATE({ item: note }));
            }
        }
        // const notesChats = noteChatResource.selectors.items(store.getState()).filter((x) => noteChatResource.fields.error(x));
        // for (const notesChat of notesChats) {
        //     if (noteChatResource.fields.neverCommited(notesChat)) {
        //         store.dispatch(noteChatResource.actions.CREATE({ item: notesChat }));
        //     } else {
        //         store.dispatch(noteChatResource.actions.UPDATE({ item: notesChat }));
        //     }
        // }        
        const bookmarks = bookmarksResource.selectors.items(store.getState()).filter((x) => bookmarksResource.fields.error(x));
        for (const bookmark of bookmarks) {
            if (bookmarksResource.fields.neverCommited(bookmark)) {
                store.dispatch(bookmarksResource.actions.CREATE({ item: bookmark }));
            } else {
                store.dispatch(bookmarksResource.actions.UPDATE({ item: bookmark }));
            }
        }
        const categories = categoriesResource.selectors.items(store.getState()).filter((x) => categoriesResource.fields.error(x));
        for (const category of categories) {
            if (categoriesResource.fields.neverCommited(category)) {
                store.dispatch(categoriesResource.actions.CREATE({ item: category }));
            } else {
                store.dispatch(categoriesResource.actions.UPDATE({ item: category }));
            }
        }

        const admins = beheerResource.selectors.items(store.getState()).filter((x) => beheerResource.fields.error(x));
        for (const admin of admins) {
            if (beheerResource.fields.neverCommited(admin)) {
                store.dispatch(beheerResource.actions.CREATE({ item: admin }));
            } else {
                store.dispatch(beheerResource.actions.UPDATE({ item: admin }));
            }
        }        

        const questions = questionsResource.selectors.items(store.getState()).filter((x) => questionsResource.fields.error(x));
        for (const question of questions) {
            if (questionsResource.fields.neverCommited(question)) {
                store.dispatch(questionsResource.actions.CREATE({ item: question }));
            } else {
                store.dispatch(questionsResource.actions.UPDATE({ item: question }));
            }
        }   
    }
    return next(action);
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/errorControl/middleware.tsx